const isValid = content => {

  if (typeof content === 'string' && /^[\],:{}\s]*$/.test(content.replace(/\\["\\bfnrtu]/g, '@')
  .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/g, ']')
  .replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
    return true
  }else{
    return false
  }
}

export default {
  isValid
}



// WEBPACK FOOTER //
// ./src/utils/json.js